export default __webpack_public_path__ + "static/media/114.918ece29.png";